import module from 'cliente/module.js'
import template from './template.html'

export class ClienteFacturasFacturaComponent {
  idCliente
  rfcEmpresa
  folio
  serie
  data = null

  constructor (ClienteFacturasFactura) {
    this.ClienteFacturasFactura = ClienteFacturasFactura
  }

  $onInit () {
    return this.ClienteFacturasFactura.get(this.idCliente, this.rfcEmpresa, this.folio, this.serie)
      .then(({data}) => (this.data = data))
  }

  generarCFDI (formato) {
    return this.ClienteFacturasFactura.generarCFDI(this.idCliente, this.rfcEmpresa, this.folio, this.data.id_comprobante, formato)
  }
}

module.component('clienteFacturasFactura', {
  controller: ClienteFacturasFacturaComponent,
  template,
  bindings: {
    idCliente: '<',
    rfcEmpresa: '<',
    folio: '<',
    serie: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/facturas/factura/component.js